import { deburr } from 'lodash-es';

export const isValueMatchingSearchTerm = (value: string, searchTerm: string, locale: string) =>
    deburr(value.toLocaleLowerCase(locale)).includes(deburr(searchTerm.toLocaleLowerCase(locale)));
